import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OnWidthChangeService {
  callBack: () => void;
  emit() {
    try {
      this.callBack();
    } catch (e) {
      // ignore of it is not used
    }
  }
}
